/* 周瑜傳・第 4 章：巴丘（建安十五年，210）
 * 史實：《三國志·周瑜傳》「瑜乃詣京見權曰：『今曹操新折衄，方憂在腹心，未能與將軍連兵相事也。乞與奮威俱進取蜀，得蜀而并張魯，
 *       因留奮威固守其地，好與馬超結援。瑜還與將軍據襄陽以蹙操，北方可圖也。』權許之。瑜還江陵為行裝，而道於巴丘病卒，時年三十六。
 *       權素服舉哀，感動左右。」
 *       《江表傳》（裴注）：程普「與周公瑾交，若飲醇醪，不覺自醉」；孫權稱尊號後說「孤非周公瑾，不帝矣」。
 *       《龐統傳》：「吳將周瑜助先主取荊州，因領南郡太守。瑜卒，統送喪至吳。」
 * 流程：不打仗的一章。周瑜回到江陵治行裝：城裡的倉（糧）、庫（兵器），城外的兵營（點兵）、城南的船場（整船），四件事都要走到、站著辦完。
 *       周瑜病了：體力一直往下掉，走路掉得更快、每辦一件事也要耗體力；回太守府歇息可以回一些，但出師的日子不等人。
 *       四件事辦完就上船，順江往東。船到巴丘……（劇情） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel } from '../kit.ts';
import { PREP, DOCK, BAQIU } from '../maps/zhouyu_nanjun.ts';

const LV = 14, DUE = 110, VIT0 = 80, IDLE = 0.32, WALK = 0.75, SAIL = 0.3, TASK_T = 3, TASK_COST = 9, REST_T = 4, REST_GAIN = 30;
const TASKS = [['cang', '倉', '治糧（倉）', '軍糧裝船，夠走到蜀地。'], ['ku', '庫', '治兵器（庫）', '弓弩甲冑都點清了。'], ['ying', '營', '點兵（兵營）', '各營將士整隊，聽候出發。'], ['dock', '船', '整船（船場）', '樓船、走舸都修好了。']];

export default {
  id: 'zhouyu-4', map: 'zhouyu_nanjun', hero: 'zhouyu', gold: 0,
  title: '第 4 章　巴丘', year: '建安十五年（210）',
  brief: {
    quote: [{ text: '瑜還江陵為行裝，而道於巴丘病卒，時年三十六。', src: '《三國志·吳書·周瑜傳》' }],
    text: '周瑜到京口見孫權，請求和奮威將軍孫瑜一起進取蜀地，再回頭與孫權據襄陽、逼曹操。孫權答應了。周瑜回江陵準備出征，但他已經病了。',
    goals: ['治行裝：倉、庫、兵營、船場四件事', '體力不支就回太守府歇息', '上船，順江往東'],
  },
  words: { ally: '吳兵', foe: '' },
  stars: [
    { text: '出師之前聽程普說「若飲醇醪」', ok: (m) => !!m.vars.chun },
    { text: '出師之期前 40 秒就上船', ok: (m) => m.vars.boardT != null && m.vars.boardT <= DUE - 40 },
    { text: '如史：沒有歇息，一口氣辦完行裝', ok: (m) => m.vars.rests === 0 },
  ],
  steps: [
    { // 0. 治行裝
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = PREP.fu[0]; me.y = PREP.fu[1] + 60;
        V.t0 = w.t; V.vit = VIT0; V.rests = 0; V.done = {};
        w.addBuff(me, { id: '病', t: 9999, neg: true, ms: -0.15 });
        TASKS.forEach(([k, label]) => m.mark(k, PREP[k][0], PREP[k][1], label, true));
        m.mark('fu', PREP.fu[0], PREP.fu[1], '太守府（歇息）', true);
        // 府中的人
        m.folk(PREP.fu[0] + 120, PREP.fu[1] + 40, { name: '龐統', still: true, near: 170, lines: [['龐統', '府君氣色不好，行裝的事交給下面的人辦吧。'], ['周瑜', '取蜀之事，是我向至尊請來的。我自己辦。']] });
        m.folk(PREP.ying[0] + 160, PREP.ying[1] - 40, { name: '程普', still: true, near: 170, lines: [['程普', '公瑾，又要遠行了？'], ['程普', '我年長，早年常常凌侮你，你從不計較。'], ['程普', '與周公瑾交，若飲醇醪，不覺自醉。']], onHeard: () => { V.chun = true; } });
        m.card('瑜乃詣京見權曰：「乞與奮威俱進取蜀，得蜀而并張魯，因留奮威固守其地，好與馬超結援。瑜還與將軍據襄陽以蹙操，北方可圖也。」權許之。', '《周瑜傳》');
        m.after(6, () => m.line('周瑜', '回江陵治行裝。……咳。'));
        m.after(10, () => m.line('提示', '周瑜病了：體力一直往下掉，走路掉得更快。四處各站著辦一會兒；撐不住就回太守府歇息（但出師的日子不等人）。'));
        m.obj('prep', '治行裝', 4);
        m.obj('vit', '');
        m.obj('due', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        TASKS.forEach(([k, , , say]) => {
          if (V.done[k]) return;
          m.chanAt(me, k, PREP[k][0], PREP[k][1], 150, TASK_T, '治行裝', () => {
            V.done[k] = true; V.vit -= TASK_COST; m.unmark(k); m.line('周瑜', say);
            m.prog('prep', Object.keys(V.done).length);
          }, { hurt: false });
        });
        if (V.vit < VIT0) m.chanAt(me, 'rest', PREP.fu[0], PREP.fu[1], 140, REST_T, '歇息', () => { V.rests++; V.vit = Math.min(VIT0, V.vit + REST_GAIN); m.line('周瑜', '……好些了。'); }, { hurt: false });
        return Object.keys(V.done).length === 4;
      },
    },
    { // 1. 上船
      enter(m, w) {
        const V = m.vars;
        m.done('prep'); m.unmark('fu');
        m.mark('dock', DOCK[0], DOCK[1], '登船');
        m.line('周瑜', '行裝都齊了。上船。');
        m.obj('board', '到船場登船');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!m.near(me, DOCK[0], DOCK[1], 160)) return false;
        V.boardT = w.t - V.t0;
        return true;
      },
    },
    { // 2. 順江往東
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('board'); m.unmark('dock'); m.drop('due');
        V.b = m.boat(me, { x: DOCK[0], y: DOCK[1] + 340, sp: 170, flag: '#c0302a', big: true });
        m.mark('bq', BAQIU[0], BAQIU[1], '巴丘');
        m.line('提示', '右鍵點江面划船，順江往東。');
        m.obj('sail', '順江往東，到巴丘');
      },
      tick(m, w) { return m.near(w.player, BAQIU[0], BAQIU[1], 320); },
    },
    { // 3. 道於巴丘病卒
      enter(m, w) {
        const V = m.vars;
        V.end = true; m.done('sail'); m.unmark('bq'); m.drop('vit');
        V.b.goal = null; V.b.stop = true;
        m.line('周瑜', '……奮威，蜀地……就拜託……');
        m.after(4, () => m.card('瑜還江陵為行裝，而道於巴丘病卒，時年三十六。', '《周瑜傳》'));
        m.after(9, () => m.card('權素服舉哀，感動左右。喪當還吳，又迎之蕪湖，眾事費度，一為供給。', '《周瑜傳》'));
        m.after(14, () => m.card('瑜卒，統送喪至吳，吳人多聞其名。', '《龐統傳》'));
        m.after(19, () => m.card('後權稱尊號，謂公卿曰：「孤非周公瑾，不帝矣。」', '《江表傳》（裴注）'));
        m.after(24, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (V.vit == null || V.end) return;
    const I = me.input || {}, moving = !me.boat && (I.moveTo || (I.wp && I.wp.length));
    V.vit -= (me.boat ? SAIL : moving ? WALK : me.chan ? 0 : IDLE) * dt; // 歇息、辦事讀條時不另外掉
    const left = DUE - (w.t - V.t0);
    m.get('vit').text = `體力 ${Math.max(0, Math.round(V.vit))} / ${VIT0}`;
    if (m.get('due')) m.get('due').text = left > 0 ? `出師之期：還有 ${Math.ceil(left)} 秒` : '出師之期已過';
    if (V.vit <= 0) { m.lose('病重不起，未能成行'); return; }
    if (left <= 0 && m.i < 2) m.lose('誤了出師之期');
  },
};
